import clientSay1 from "images/clientSay1.png";
import clientSay4 from "images/clientSay4.png";
import clientSay5 from "images/clientSay5.png";

export const globalJson = {
  //
  prod_company_id: 247,
  dev_company_id: 247, //
  // apiUtil auth header key
  authToken: "Bearer 156|58t8SSr5MhZhuScrt9qczI7ywigBQQzfLGDO24SM",
  companyId: "a75b8a81-d900-402f-b0c3-5a362ff0f652",
  stripePublishableKey:
    "pk_live_51LdnoABqYa4ICTHoC6CjEgImHYOvUXXPs8psg8jZqXPxRwBt99nQEWtFFJj2n3ublkCJa0S8pYzDtvStF2JxUPzU00uWCskvlb",
  mapKey: "AIzaSyDKEntg7JydrxI7zr2tQL5OYcS5M-er-bc",
  residenceStateCode: "FL",

  //email confirmation admin token
  adminEmailToken:
    "vuRJfhz4wO5Odhxv682si70x95UA7zOxqz7sK2r7L8LJMXTsWiKM53edU24y4LYVgFqj4oI3OmaRFzDWoXA9GdCqNfyOciVYw9GO0kbDOepigLabYZDgnkw0ih6uLUgi",
  websiteLink: "https://mopacrental.com",
  sender: "mopac",
  ccEmail: "smartprentals@gmail.com",

  // apiUtil sendNewsLetterEmail
  util_serviceId: "service_0qh0217",
  util_templateId: "template_k4swowo",
  util_userId: "XU0TvMOEGy9VJQE5T",
  util_privateKey: "b3uzElNArs8Koz0Y9zWvo",

  // apiUtil getBonzahToken
  client_secret_dev:
    "SLxANOhVR/O9HK7QDelJBvbsz+i/XW5zVXYe49JeHyaHbf2RAvKunJyFWebq5ImbJpRDdUaEIp3Zu9fDL5Yt7VMX7lqe8iCMBzveJp1RfCM+Y+l5SW3iMMhO9h/8GDAwaCpZmg==",
  client_id_dev:
    "ab560362-ffc6-4dc7-a16a-fd43845deefc-20240522074089-vendor@bonzah.com",
  client_secret_prod:
    "SUnRy0BcS3KlKZFKcZljUTgxjm16B+lkDObgCvwe+Cyn4NIC1AqXwJgG4M4Z+6OyWphxUbNkrKr2F1WL9jxuhW3jLn9s0gBb8qF3ZxV4A18oWelsjDAg7CC1UHkPMQNH0A6+OA==",
  client_id_prod:
    "3646ae7f-dd0a-4aed-bd7e-f2d4bc9b3036-20240522501529-vendor@bonzah.com",

  about_us_para:
    "Welcome to Autowurx, where your dream drive begins! Founded in September 2023 by two passionate young entrepreneurs, our mission is to redefine car rentals in New York. We believe that everyone deserves a seamless, stylish, and unforgettable driving experience, whether you’re a local looking for the perfect ride or a traveler exploring the vibrant streets of NYC At Autowurx, we combine innovation, exceptional service, and a carefully curated fleet of vehicles to meet every customer’s unique needs. From sleek luxury cars to practical and reliable options, we’re here to turn your journey into a dream come true. We’re more than just a car rental company—we’re a community-focused business that values trust, quality, and creating lasting memories. Whether it’s for business, leisure, or adventure, Autowurx is here to help you hit the road with confidence and style. Thank you for choosing us. Let’s drive your dream together!",

    clientSays_arr: [
      {
        id: 1,
        clientName: "John D.",
        clientAddress: "Dodge Grand Caravan 2019",
        content:
          "The service was excellent, and the car was in top-notch condition. I'll definitely rent from here again!",
        img: clientSay1,
      },
      {
        id: 2,
        clientName: "Samantha L.",
        clientAddress: "LondDodge Grand Caravan 2019",
        content:
          "The process was so smooth, and I appreciated the friendly staff. Highly recommend this company for car rentals!",
        img: clientSay4,
      },
      {
        id: 3,
        clientName: "Michael R.",
        clientAddress: "Dodge Grand Caravan 2019",
        content:
          "The car was clean, affordable, and reliable. I had a great experience and will use them again for my next trip!",
        img: clientSay5,
      },
    ],

  //social links
  facebook: "https://www.facebook.com",
  instagram: "https://www.instagram.com",

  //contact
  address: "8101 Sandy Spring Road Suite 300 Laurel Md 20707",
  addressLink:
    "https://www.google.com/maps/place/4830+W+Kennedy+Blvd,+Tampa,+FL+33609,+USA/data=!4m2!3m1!1s0x88c2c2e4b61fbe87:0x7fa31f86943d0895?sa=X&ved=1t:242&ictx=111",
  phone: "+1 410-417-8588",
  email: "Rentals@autowurx.net",
};

export const scriptHubSpot = document.createElement("script");
scriptHubSpot.src = "//js-na1.hs-scripts.com/46394417.js";
scriptHubSpot.async = true;
scriptHubSpot.defer = true;
scriptHubSpot.id = "hs-script-loader";
